export function getPoiImageUrl(image: string, width = 360, height = 360) {
	const accountId = process.env.LOCUS_LABS_ACCOUNT_ID;

	return `https://img.locuslabs.com/resize/${accountId}/${width}x${height}cc/poi/${image}`;
}
